// extracted by mini-css-extract-plugin
module.exports = {"mobileColumns":"styles-module__mobileColumns___3Pxsx","columns":"styles-module__columns___-hQGH","next":"styles-module__next___3fpBB","prev":"styles-module__prev___2yRsL"};